module.exports = __webpack_public_path__ + "static/media/caret-arrow-down.43772456.svg";